import React from 'react';

const SvgParking = ({ title, ...props }) => (
  <svg
    id="parking_svg__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 50 50"
    xmlSpace="preserve"
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <style>{'.parking_svg__st1{fill-rule:evenodd;clip-rule:evenodd}'}</style>
    <circle
      cx={25}
      cy={25}
      r={22}
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#fff"
    />
    <path
      className="parking_svg__st1"
      d="M25 0C11.2 0 0 11.2 0 25s11.2 25 25 25 25-11.2 25-25S38.8 0 25 0zm3.6 30.1h-7.2v11.1h-6.8v-31h14c7.7 0 10.7 4.9 10.7 9.9.1 5.1-2.9 10-10.7 10z"
    />
    <path
      className="parking_svg__st1"
      d="M26.8 15.5h-5.3v9.3h5.3c3.2 0 6-.7 6-4.6 0-4-2.9-4.7-6-4.7z"
    />
  </svg>
);

export default SvgParking;
